// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__3NjAA","choiceBoxes":"toolbarselects_choiceBoxes__3CRdS","simpleField":"toolbarselects_simpleField__HVAbQ"};